<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>star</mat-icon>
      {{ listingTitle }}
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section mat-dialog-content>
    <table mat-table [dataSource]="LocalOffers">
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <ng-container matColumnDef="company_name">
        <th mat-header-cell *matHeaderCellDef>Company Name</th>
        <td mat-cell *matCellDef="let row">{{row.company_name }}</td>
      </ng-container>
      <ng-container matColumnDef="offer">
        <th mat-header-cell *matHeaderCellDef>Offer</th>
        <td mat-cell *matCellDef="let row">{{row.offer }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions">
          <button (click)="editOffer()" mat-icon-button matTooltip="Add offer">
            <mat-icon>add</mat-icon>
          </button>
        </th>
        <td mat-cell *matCellDef="let row" class="actions">
          <button
            (click)="editOffer(row)"
            mat-icon-button
            matTooltip="Edit local offer"
            >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            (click)="deleteLocalOffer(row)"
            mat-icon-button
            matTooltip="Delete Local Offer"
            >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>
    </table>
    @if (PageEvent) {
      <mat-paginator
        (page)="DataSource.loadWithPageEvent($event)"
        [length]="PageEvent.length"
        [pageIndex]="PageEvent.pageIndex"
        [pageSize]="PageEvent.pageSize"
      ></mat-paginator>
    }
  </section>
</section>
